module.exports = __webpack_public_path__ + "img/vp03.880ccaa7.jpg";